import {createFileRoute} from '@tanstack/react-router'

import {zeroLevelIndexRoute} from "../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/offers/$username/')({
    ...zeroLevelIndexRoute("/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
});

